import { type Editor } from '@tiptap/react';
import { Grid2x2XIcon } from 'lucide-react';

import { DropdownMenuWrapper, useDropdownMenuState } from '@/components/ui/tiptap/tiptap-ui-primitives';
import { useIsTableInactive } from '@/components/ui/tiptap/tiptap-ui/table';
import { useTiptapEditor } from '@/hooks/tiptap';
import { isNodeInSchema, shouldShow } from '@/lib/tiptap';

import type { DeleteDropdownMenuProps, DeleteTableElementType } from '.';

import { DeleteColRowButton, deleteColRowOptions } from '.';

export function DeleteDropdownMenu(deleteDropdownMenuProps: DeleteDropdownMenuProps) {
  const { editor: providedEditor, onOpenChange, types = ['deleteColumn', 'deleteRow', 'deleteTable'], ...props } = deleteDropdownMenuProps;

  const editor: Editor | null = useTiptapEditor(providedEditor);
  const inSchema: boolean = isNodeInSchema('table', editor);
  const isDisabled: boolean = useIsTableInactive(editor);

  const { isOpen, filteredItems, handleOpenChange, activeIcon } = useDropdownMenuState<DeleteTableElementType>(editor, types, deleteColRowOptions, undefined, <Grid2x2XIcon />);

  const show: boolean = shouldShow([!!editor, inSchema]);

  if (!show || !editor || !editor.isEditable) {
    return null;
  }

  return (
    <DropdownMenuWrapper
      isOpen={isOpen}
      onOpenChange={(open) => handleOpenChange(open, onOpenChange)}
      ariaLabel="delete column, row or table"
      buttonProps={props}
      activeIcon={activeIcon()}
      isDisabled={isDisabled}
      isActive={false}
    >
      {filteredItems.map((item) => (
        <DeleteColRowButton key={item.type} editor={editor} type={item.type} />
      ))}
    </DropdownMenuWrapper>
  );
}
